import React from 'react'
import PropTypes from 'prop-types'
import { MrModal } from '@hixme/modal'

import Container from '@hixme-ui/container'
import Text from '@hixme-ui/text'

import { containers } from 'store/modules/person-coverage'

import { PERSON_COVERAGE_MODAL_STYLE } from './personCoverageModalStyle'

const { PersonCoverageFormContainer } = containers

const PersonCoverageModal = ({ description, ...formProps }) => (
  <MrModal
    hideCloseButton
    title="Who would you like to cover?"
    style={PERSON_COVERAGE_MODAL_STYLE}
    contentPadding="24px"
  >
    <Container flex alignCenter direction="column" noPadding width="100%">
      <Container noPadding textCenter margin="0 0 24px 0" width="100%">
        <Text medium light thin>
          {description}
        </Text>
      </Container>
      <PersonCoverageFormContainer {...formProps} />
    </Container>
  </MrModal>
)

PersonCoverageModal.displayName = 'PersonCoverageModal'

PersonCoverageModal.propTypes = {
  description: PropTypes.string.isRequired,
}

export default PersonCoverageModal
